import { StrictDict } from '../../utils';

/* eslint-disable import/prefer-default-export */
export const blockTypes = StrictDict({
  html: 'html',
  video: 'video',
  problem: 'problem',
  // ADDED_EDITORS GO BELOW
  video_upload: 'video_upload',
  game: 'game',
  // ADVANCE_MODULES
  scorm: 'scorm',
});
